import Base from '../Base';

export interface ConfigEHSS extends Base {
    auditedsByAuditor: number;
    auditedGoal: Frequency;
    auditorGoal: Frequency;
    remainderDays?: number;
}

interface Frequency {
    times: number;
    type: FrequencyType;
}
export enum FrequencyType {
    DAYS = 1,
    MONTHS = 2,
    YEARS = 3,
    HOUR = 4,
    MINUTES = 5
}